import React from "react";
import CountUp from "react-countup";
import "../styles/About.css";
import aboutVideo from "../assets/images/about.mp4";


function About() {
  return (
    <div className="about-page">
      <h2 className="about-heading">Who We Are</h2>
      <p className="about-description">
        We are a dynamic, full-service Technological Innovation company, specializing in innovative design and web development. 
        With over five years of industry expertise and a deep passion for technology, we empower businesses with creative 
        digital strategies that drive growth, enhance brand identity, and streamline user experiences.
      </p>

      <div className="about-stats">
  <video
    className="background-video"
    src={aboutVideo}
    autoPlay
    loop
    muted
    playsInline
  />
  
  <div className="stats-content">
    <div className="stat-card">
      <h3><CountUp end={3} duration={3} suffix="+"/></h3>
      <p>Years in Business</p>
    </div>
    <div className="stat-card">
      <h3><CountUp end={36} duration={3} suffix=""/></h3>
      <p>Project Completed</p>
    </div>
    <div className="stat-card">
      <h3><CountUp end={13} duration={3} suffix=""/></h3>
      <p>Project Launched</p>
    </div>
    <div className="stat-card">
      <h3><CountUp end={31} duration={3} suffix=""/></h3>
      <p>Client Satisfaction</p>
    </div>
  </div>
</div>

    </div>
  );
}

export default About;

